module.exports = __webpack_public_path__ + "static/media/logo1.88ae0c12.png";